// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  position: absolute;
  padding: 4px var(--spacing-mini);
  font-size: var(--font-size-small);
  white-space: nowrap;
  opacity: 0;
  transform: scaleX(0);
  pointer-events: none;
  z-index: 100;
}

.tooltip.top {
  transform: translateY(-10px);
}

.tooltip.bottom {
  transform: translateY(10px);
}

.tooltip.left {
  transform: translateX(-10px);
}

.tooltip.right {
  transform: translateX(10px);
  border-radius: 15px 20px 20px 2px;
  transform-origin: left center;
  animation: tooltip-appear 0.2s ease-out forwards;
}

@keyframes tooltip-appear {
  0% {
    transform: scaleX(0);
    opacity: 0;
  }
  100% {
    transform: scaleX(1);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/base/tooltip.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;EACA;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF","sourcesContent":[".tooltip {\n  position: absolute;\n  padding: 4px var(--spacing-mini);\n  font-size: var(--font-size-small);\n  white-space: nowrap;\n  opacity: 0;\n  transform: scaleX(0);\n  pointer-events: none;\n  z-index: 100;\n}\n\n.tooltip.top {\n  transform: translateY(-10px);\n}\n\n.tooltip.bottom {\n  transform: translateY(10px);\n}\n\n.tooltip.left {\n  transform: translateX(-10px);\n}\n\n.tooltip.right {\n  transform: translateX(10px);\n  border-radius: 15px 20px 20px 2px;\n  transform-origin: left center;\n  animation: tooltip-appear 0.2s ease-out forwards;\n}\n\n@keyframes tooltip-appear {\n  0% {\n    transform: scaleX(0);\n    opacity: 0;\n  }\n  100% {\n    transform: scaleX(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
